/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Why_Standard_SubtitleInputs */



/**
* | output |
* | --- |
* | "Everything teams need to move fast with confidence." |
*
* @param {Pricing_Why_Standard_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const pricing_why_standard_subtitle = /** @type {((inputs?: Pricing_Why_Standard_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Why_Standard_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Alles, was Teams brauchen, um schnell und sicher zu handeln.")
	return /** @type {LocalizedString} */ ("Everything teams need to move fast with confidence.")
});